export class YearPeriod {

    start: number[] = null;

    end: number[] = null;

    static toStringOf(yearPeriod: YearPeriod): string {
        if (yearPeriod && yearPeriod.start) {
            if (yearPeriod.end) {
                return `${this.toStringOfDate(yearPeriod.start)}-${this.toStringOfDate(yearPeriod.end)}`;
            }

            return this.toStringOfDate(yearPeriod.start);
        }

        return '';
    }

    private static toStringOfDate(start: number[]): string {
        if (start && start.length > 0) {
            return `${start[2].valueOf() < 10 ?
                `0${start[2]}` :
                start[2]}.${start[1].valueOf() < 10 ? `0${start[1]}` : start[1]}.${start[0]}`;
        }

        return '';
    }
}
